<template>
    <div class="row justify-content-center">
        <transition name="fade" mode="out-in">
            <AppPlaceholder class="col-xl-8" v-if="!region" key="no-region"/>
            <div v-else class="col-xl-8" key="region">
                <div class="row">
                    <div class="col-12 mb-4 d-sm-flex justify-content-between align-items-baseline">
                        <div class="pl-3">
                            <h4>
                                {{ isNew
                                ? 'New region'
                                : region.name }}
                            </h4>
                            <p class="mb-0 text-muted" v-if="!isNew">
                                <small>Created on {{ region.created_at | date }}</small>
                            </p>
                        </div>
                        <div class="col-12 col-sm-auto text-right pr-0 mt-2 mt-sm-0">
                            <button class="btn btn-primary mr-2"
                                    :disabled="loading"
                                    @click="save">
                                Save
                            </button>
                            <button class="btn btn-outline-secondary"
                                    :disabled="loading"
                                    @click="saveAndClose">
                                Save & close
                            </button>
                            <b-dropdown variant="link"
                                        no-caret
                                        right
                                        v-if="!isNew">
                                <template v-slot:button-content>
                                    <i class="material-icons">more_vert</i>
                                </template>
                                <b-dropdown-item :disabled="loading"
                                                 @click="destroy">
                                    Delete
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <AppInput label="Name"
                                      :value="region.name"
                                      field="name"
                                      :errors="errors"
                                      @change="updateRegionProps({ name: $event })"
                                      class="col-md-6"/>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { BDropdown, BDropdownItem } from 'bootstrap-vue';
import NotificationService from '../../services/notification.service';
import AppInput from '../form/AppInput';
import AppPlaceholder from '../form/AppPlaceholder';
import Errors from '../../utils/errors';
import { formatDate } from '../../filters/date.filter';

export default {
  components: {
    AppInput,
    AppPlaceholder,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      canClose: false,
    };
  },

  filters: {
    date: formatDate,
  },
  computed: {
    ...mapGetters({
      region: 'regions/region',
    }),
    isNew() {
      return this.$route.params.id === 'new';
    },
  },
  mounted() {
    this.initRegion();
  },
  watch: {
    '$route.params.id'() {
      this.initRegion();
    },
  },
  methods: {
    initRegion() {
      return this.isNew
        ? this.$store.dispatch('regions/newRegion')
        : this.getRegion();
    },
    getRegion() {
      this.$store.dispatch('regions/getRegion', this.$route.params.id);
    },
    updateRegionProps(props) {
      this.$store.dispatch('regions/updateRegionProps', props);
    },
    saveAndClose() {
      this.save()
        .then(() => {
          if (this.canClose) {
            this.$router.push({ name: 'regions' });
          }
        });
    },
    save() {
      this.loading = true;
      this.errors.clear();
      return this.$store.dispatch(this.isNew ? 'regions/createRegion' : 'regions/updateRegion')
        .then((res) => {
          this.canClose = true;
          if (this.isNew) {
            this.$router.push({
              name: 'region',
              params: { id: res.region_id },
            });
          }
          NotificationService.success(res.message);
        })
        .catch((err) => {
          this.canClose = false;
          this.errors.set(err.response.data.errors);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    destroy() {
      this.$bvModal.msgBoxConfirm('Delete region?', {
        okTitle: 'Delete',
        okVariant: 'danger',
      })
        .then((value) => {
          if (value) {
            this.$store.dispatch('regions/deleteRegion')
              .then((res) => {
                NotificationService.success(res.message);
                this.$router.push({ name: 'regions' });
              });
          }
        });
    },
  },
};
</script>
